module.exports = __webpack_public_path__ + "img/onboarding-modal-image-01.51bc7c2.svg";